/* eslint-disable @typescript-eslint/no-explicit-any */

import { Card, Input, InputNumber } from "antd";

export default function MatItems(props: any) {
  const { matItemData, color, setGroupedData, serviceLineId } = props;
  return (
    <Card
      className={`${color} estimateServicesList`}
      style={{ cursor: "pointer" }}
    >
      <div className="top_wrap" style={{ margin: 0 }}>
        <div className="top_wrap_left">
          <h4>
            <Input
              type="text"
              onChange={(e) => {
                setGroupedData((prevData: any) => {
                  return prevData.map((serviceLine: any) => {
                    if (serviceLine.service_line_id === serviceLineId) {
                      return {
                        ...serviceLine,
                        line_items: serviceLine.line_items.map((item: any) =>
                          item.id === matItemData.id
                            ? { ...item, name: e.target.value }
                            : item
                        ),
                      };
                    }
                    return serviceLine;
                  });
                });
              }}
              value={matItemData?.name || ""}
              className="lineItemInput"
              placeholder="Enter line item"
            />
          </h4>
        </div>
        <Card className="innerCard">
          <div className="innerCardBox">
            <p>Total cost:</p>
            <h3>
              <InputNumber
                controls={false}
                className="serviceLineInput"
                addonBefore="$"
                placeholder="0"
                value={matItemData?.total_cost || ""}
                onChange={(e) => {
                  setGroupedData((prevData: any) => {
                    return prevData.map((serviceLine: any) => {
                      if (serviceLine.service_line_id === serviceLineId) {
                        return {
                          ...serviceLine,
                          line_items: serviceLine.line_items.map(
                            (item: any) => {
                              if (item.id === matItemData.id) {
                                const totalPrice = item.total_cost
                                  ? (e * 100) /
                                    (100 - (item.gross_margin_perc || 0))
                                  : 0;
                                return {
                                  ...item,
                                  total_cost: e,
                                  total_price: totalPrice,
                                };
                              } else {
                                return item;
                              }
                            }
                          ),
                        };
                      }
                      return serviceLine;
                    });
                  });
                }}
              />
            </h3>
          </div>
          <div className="innerCardBox">
            <p>Total price:</p>
            <h3>
              ${Number(matItemData?.total_price?.toFixed(2)).toLocaleString()}
            </h3>
          </div>
          <div className="innerCardBox">
            <p>GM:</p>
            <h3>
              <InputNumber
                className="serviceLineInput"
                addonAfter={<span>%</span>}
                placeholder="0"
                controls={false}
                max={99}
                min={0}
                value={matItemData?.gross_margin_perc || ""}
                onChange={(e) => {
                  setGroupedData((prevData: any) => {
                    return prevData.map((serviceLine: any) => {
                      if (serviceLine.service_line_id === serviceLineId) {
                        return {
                          ...serviceLine,
                          line_items: serviceLine.line_items.map(
                            (item: any) => {
                              if (item.id === matItemData.id) {
                                const totalPrice = item.total_cost
                                  ? (item?.total_cost * 100) / (100 - (e || 0))
                                  : 0;
                                return {
                                  ...item,
                                  gross_margin_perc: e,
                                  total_price: totalPrice,
                                };
                              } else {
                                return item;
                              }
                            }
                          ),
                        };
                      }
                      return serviceLine;
                    });
                  });
                }}
              />
            </h3>
          </div>
        </Card>
      </div>
    </Card>
  );
}
